import React from "react";
import Container from "../../../utils/Container";
import failedMas from "../../../assets/failed.png";
import { useNavigate } from "react-router";

const HotelBookingFailed = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Container>
        <div className="flex flex-col items-center justify-center h-full py-32">
          <div className="w-32 lg:w-48 h-full">
            <img
              src={failedMas}
              className="w-full h-full object-contain"
              alt=""
            />
          </div>
          <p className="text-md lg:text-lg font-semibold text-center">
            Sorry😔! You've failed to book your hotel. <br />
            Do not worry check your dashboard to book again or contact support
            for assistance.
          </p>
          <div className="mt-5">
            <button
              className="bg-[#161f52] hover:bg-[#0a0e25] duration-300 text-white font-bold py-2 px-4 rounded"
              onClick={() => navigate("/customer/dashboard")}
            >
              Check Your Booking
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HotelBookingFailed;
